var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortDesc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90, 7, 7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70714 0.292893C9.31661 -0.0976311 8.68345 -0.0976311 8.29292 0.292893C7.9024 0.683418 7.9024 1.31658 8.29292 1.70711L10.5858 4L3.00003 4C2.44775 4 2.00003 4.44772 2.00003 5C2.00003 5.55228 2.44775 6 3.00003 6L13 6C13.4045 6 13.7691 5.75636 13.9239 5.38268C14.0787 5.00901 13.9931 4.57889 13.7071 4.29289L9.70714 0.292893Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00003 8C0.595567 8 0.230931 8.24364 0.0761497 8.61732C-0.0786313 8.99099 0.00692445 9.42111 0.292922 9.70711L4.29292 13.7071C4.68345 14.0976 5.31661 14.0976 5.70714 13.7071C6.09766 13.3166 6.09766 12.6834 5.70714 12.2929L3.41424 10H11C11.5523 10 12 9.55229 12 9C12 8.44771 11.5523 8 11 8H1.00003Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDesc);
export default __webpack_public_path__ + "static/media/sort-desc.2f497cd84a1c00f65ba743030e0eb532.svg";
export { ForwardRef as ReactComponent };